import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import {push} from 'react-router-redux';

import * as styles from '../../styles';
import {imageUrl} from '../../utilities/requests';
import {request} from '../../containers/actions';


export default class Paper extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    state = {
        page: 0,
    };

    componentDidMount() {
        this.fetch.bind(this)();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.params.examinationId !== this.props.params.examinationId) {
            this.fetch.bind(this)();
        }
        if (prevState.page !== this.state.page) {
            const paper = _.find(this.state.papers, paper => paper.page === this.state.page);
            let img = this.refs?.image;
            if(img)
            {
                img.removeAttribute('src');
            }
            this.refs.image.src = imageUrl(paper?.image, {height: 1000, type: 'contain'});
        }
    }

    async fetch() {
        this.setState({fetching: true});
        const questions = (await this.context.store.dispatch(request({
            path: `/examination/${this.props.params.examinationId}/?detailed`,
        }))).questions;
        let papers = [];
        if (!this.props.only_key)
            papers = (await this.context.store.dispatch(request({
                path: '/paper/?' + queryString.stringify({
                    limit: 100,
                    examination: this.props.params.examinationId,
                    student: this.props.params.studentId,
                    minimal: true,
                }),
            }))).results;
        this.setState({questions, papers});
    }

    render() {
        const pages = ((_.maxBy(this.state.questions, 'page') || {}).page || -1) + 1;
        const paper = _.find(this.state.papers, paper => paper.page === this.state.page);
        return <div style={{position: 'relative', overflowX: 'scroll'}}>
            <div
                style={{
                    position: 'fixed',
                    backgroundColor: 'white',
                    width: '20cm',
                    height: '2cm',
                    marginRight: '.5cm',
                    marginTop: '-1em',
                    zIndex: '3',
                    padding: '1em',
                    boxSizing: 'border-box',
                    boxShadow: styles.button.boxShadow,
                    borderRadius: styles.button.borderRadius,
                }}>
                <button
                    style={{
                        ...styles.defaultButton,
                        backgroundColor: styles.fourthColor,
                        marginLeft: '.25em',
                    }}
                    onClick={() => this.context.store.dispatch(push(this.props.urls.back.format(this.props.params)))}>
                    {window.gettext('Back')}
                </button>
                <button
                    style={{
                        ...styles.defaultButton,
                        marginLeft: '.25em',
                    }}
                    onClick={() => {
                        const path = this.context.store.getState().getIn(
                            ['routing', 'locationBeforeTransitions', 'pathname'],
                        );
                        this.context.store.dispatch(push(path.split('/').slice(0, -2).join('/') + '/report/'));
                    }}>
                    {window.gettext('Report')}
                </button>
                <div
                    style={{
                        position: 'absolute',
                        top: '1em',
                        right: '50%',
                        transform: 'translateX(50%)',
                        display: 'flex',
                    }}>
                    <button
                        key='previous'
                        disabled={this.state.page === 0}
                        style={{
                            ...styles.button,
                            minWidth: undefined,
                            width: '2.3em',
                            boxShadow: undefined,
                            color: this.state.page === 0 ? '#9a9a9a' : styles.button.color,
                        }}
                        onClick={() => this.setState({page: this.state.page - 1})}>
                        <i className='fa-chevron-right'></i>
                    </button>
                    {_.map(new Array(pages), (__, page) => <button
                        key={page}
                        style={{
                            ...(this.state.page === page ? styles.activeButton : styles.button),
                            minWidth: undefined,
                            width: '2.3em',
                            fontWeight: '700',
                            boxShadow: undefined,
                        }}
                        onClick={() => this.setState({page})}>
                        {(page + 1).persian()}
                    </button>)}
                    <button
                        key='next'
                        disabled={this.state.page === pages - 1}
                        style={{
                            ...styles.button,
                            minWidth: undefined,
                            width: '2.3em',
                            boxShadow: undefined,
                            color: this.state.page === pages - 1 ? '#9a9a9a' : styles.button.color,
                        }}
                        onClick={() => this.setState({page: this.state.page + 1})}>
                        <i className='fa-chevron-left'></i>
                    </button>
                </div>
            </div>
            <div
                style={{
                    position: 'relative',
                    height: '29.7cm',
                    width: '21cm',
                    minWidth: '21cm',
                    overflow: 'hidden',
                    pageBreakAfter: 'always',
                }}>
                <div
                    style={{
                        position: 'absolute',
                        bottom: '1cm',
                        right: '1cm',
                        width: '19cm',
                        height: '0',
                        borderBottom: '.5mm solid black',
                        boxSizing: 'border-box',
                    }}>
                </div>
                {_.map(
                    _.filter(_.values(this.state.questions), item => (item.page || 0) === this.state.page),
                    item => {
                        const {top, right, width, height, content, scores} = _.mapKeys(
                            item,
                            (__, key) => key.replace(/^answer_/, ''),
                        );
                        const id = item.id;
                        return <div
                            key={id}
                            style={{
                                position: 'absolute',
                                top: top + 4 + 'cm',
                                right: right + 1 + 'cm',
                                width: width + 'cm',
                                height: height + 'cm',
                                border: '.5mm solid black',
                                boxSizing: 'border-box',
                                backgroundColor: 'white',
                                ...styles.content,
                            }}>
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '1cm',
                                    left: '100%',
                                    marginLeft: '2mm',
                                    fontWeight: '700',
                                }}>
                                {(item.index + 1).persian()}.
                            </div>
                            <div
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    overflow: 'hidden',
                                    padding: '.5cm',
                                    boxSizing: 'border-box',
                                }}
                                dangerouslySetInnerHTML={{__html: content}}
                            />
                            {_.map(scores, (score, index) => <div
                                key={index}
                                style={{
                                    position: 'absolute',
                                    display: 'flex',
                                    zIndex: '2',
                                    top: `calc(${score.top}px - 1.125em)`,
                                    right: `calc(${score.right}px - 1.125em)`,
                                    color: 'rgba(255, 0, 0, .7)',
                                    fontFamily: 'Dast Nevis',
                                    fontSize: '1.5rem',
                                    border: '.125em solid rgba(255, 0, 0, .5)',
                                    borderRadius: '50%',
                                    width: '2em',
                                    height: '2em',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    zIndex: '1',
                                }}>
                                {score.score.persian(true)}
                            </div>)}
                        </div>;
                    },
                )}
            </div>
            {paper
                ? <div
                    style={{
                        position: 'absolute',
                        top: '0',
                        right: '21.5cm',
                        width: '21cm',
                        height: '29.7cm',
                    }}>
                    <img
                        ref='image'
                        style={{width: '100%', height: '100%'}}
                        src={imageUrl(paper.image, {height: 1000, type: 'contain'})}
                    />
                    {_.map(paper.answers, answer => answer.results.length > 0
                        ? <div
                            key={answer.id}
                            style={{
                                position: 'absolute',
                                top: answer.top + 4 + 'cm',
                                right: answer.right + 1 + 'cm',
                                width: answer.width + 'cm',
                                height: answer.height + 'cm',
                            }}>
                            {_.map(answer.results[0].scores, (score, index) => <div
                                key={index}
                                style={{
                                    position: 'absolute',
                                    display: 'flex',
                                    zIndex: '2',
                                    top: `calc(${score.top}px - 1.125em)`,
                                    right: `calc(${score.right}px - 1.125em)`,
                                    color: 'rgba(255, 0, 0, .7)',
                                    fontFamily: 'Dast Nevis',
                                    fontSize: '1.5rem',
                                    border: '.125em solid rgba(255, 0, 0, .5)',
                                    borderRadius: '50%',
                                    width: '2em',
                                    height: '2em',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    zIndex: '1',
                                }}>
                                {score.score.persian(true)}
                            </div>)}
                        </div>
                        : null
                    )}
                </div>
                : null
            }
        </div>;
    }
}
